import { z } from 'zod';

/**
 * Ошибка, увиденная клиентом (mini-app). Сервер её только логирует: экран
 * «Что-то пошло не так» рождается в браузере и иначе в логи прода не попадает.
 * Длины режет клиент — сервер на превышение ответит 400, и отчёт потеряется.
 */
export const CLIENT_ERROR_MESSAGE_MAX = 1000;
export const CLIENT_ERROR_STACK_MAX = 4000;
export const CLIENT_ERROR_URL_MAX = 500;

export const ClientErrorKind = z.enum(['route', 'query', 'window', 'promise']);
export type ClientErrorKind = z.infer<typeof ClientErrorKind>;

export const ClientErrorReportInput = z.object({
  kind: ClientErrorKind,
  message: z.string().max(CLIENT_ERROR_MESSAGE_MAX),
  stack: z.string().max(CLIENT_ERROR_STACK_MAX).optional(),
  url: z.string().max(CLIENT_ERROR_URL_MAX),
  /** HTTP-статус, если упал запрос к API. */
  status: z.number().int().optional(),
  /** Ключ react-query упавшего запроса. */
  queryKey: z.string().max(CLIENT_ERROR_URL_MAX).optional(),
});
export type ClientErrorReportInput = z.infer<typeof ClientErrorReportInput>;
